// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21kEW","textarea":"styles_textarea__WQQ22"};